import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AgendaFeedbackState } from "@/types";
import { motion } from "framer-motion";
import { openClose } from "@/utils/motion/open-close.ts";
import dayjs from "dayjs";
import FeedbackOption from "@/components/agenda/mobile/feedback/Option.tsx";
import { useTranslation } from "react-i18next";
import Button from "@edusogno/primitives/button";

interface FirstPageProps {
  nextPage: (stars: { tutor: number; topicAndOrganization: number }) => void;
}
const MobileFeedbackFirstPage = ({ nextPage }: FirstPageProps) => {
  const [stars, setStars] = useState({ tutor: 0, topicAndOrganization: 0 });
  const location = useLocation();
  const data = location?.state as AgendaFeedbackState;
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <motion.div
      className="px-3 py-10 flex flex-col items-center justify-between w-full h-full"
      variants={openClose()}
    >
      <h4 className="text-2xl  my-4 font-semibold text-left text-brand-secondary">
        {t("feedback.how_was", { title: data.title })}{" "}
        {data.tutor_nome
          ? t("feedback.with_tutor", { tutor: data.tutor_nome })
          : ""}{" "}
        {dayjs(data.date).isSame(dayjs(), "day")
          ? t("feedback.today")
          : dayjs(data.date).isSame(dayjs().subtract(1, "day").clone(), "day")
          ? t("feedback.yesterday")
          : t("feedback.on_date", { date: dayjs(data.date).format("dddd") })}
        {`?`}
      </h4>
      <div className="flex flex-col items-center w-full gap-y-7">
        <FeedbackOption
          label={t("feedback.tutor_label")}
          stars={stars.tutor}
          onStarsChange={(v) =>
            setStars((r) => {
              const l = { ...r };
              l.tutor = v;

              return l;
            })
          }
        />
        <FeedbackOption
          label={t("feedback.topic_label")}
          stars={stars.topicAndOrganization}
          onStarsChange={(v) =>
            setStars((r) => {
              const l = { ...r };
              l.topicAndOrganization = v;
              return l;
            })
          }
        />
      </div>
      <div className={"flex items-center justify-center gap-x-2 "}>
        <Button size={"md"} onClick={() => navigate(-1)}>
          {t("btns.go")} {t("btns.back")}
        </Button>
        <Button
          size={"md"}
          className={"flex-grow"}
          onClick={() => {
            nextPage(stars);
          }}
          disabled={stars.topicAndOrganization === 0 || stars.tutor === 0}
        >
          {t("btns.send")}
        </Button>
      </div>
    </motion.div>
  );
};

export default MobileFeedbackFirstPage;
